import type { CSSProperties } from 'react';
import styles from './Skeleton.module.css';

export interface SkeletonProps {
  /** CSS width, e.g. `'60%'` or `'12rem'`. */
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  shape?: 'text' | 'rect' | 'circle';
  /** Number of text lines (shape `text`), the last one shorter. */
  lines?: number;
  className?: string;
}

/**
 * Placeholder while content loads, shaped like the content to come (avoids
 * layout shift). Decorative: announce loading separately, e.g. with a Spinner label.
 */
export function Skeleton({ width, height, shape = 'text', lines = 1, className }: SkeletonProps) {
  if (shape === 'text' && lines > 1) {
    return (
      <span className={[styles.lines, className].filter(Boolean).join(' ')} aria-hidden="true">
        {Array.from({ length: lines }, (_, i) => (
          <span
            key={i}
            className={`${styles.skeleton} ${styles.text}`}
            style={{ width: i === lines - 1 ? '60%' : width }}
          />
        ))}
      </span>
    );
  }
  return (
    <span
      className={[styles.skeleton, styles[shape], className].filter(Boolean).join(' ')}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}
